<section class="product-variants-section">
  <div class="title-container">
    <div class="variants-title">
      <div class="container-title">
        Product options
      </div>
      <span class="ml5">
        <i class="db-icon db-icon-ds-info-bg"
           [dsTooltip]="'text_addProductAttributesDesc'|dbText"
           dsTooltipPosition="right"
           dsTooltipColor="black"
           dsTooltipAlign="top">
        </i>
      </span>
    </div>
    <div class="view-variants-link container-action-link"
         (click)="removeVariations()">
      {{ 'text_deleteAllOptions' | dbText }}
    </div>
  </div>

  <div class="variants-list-container">
    <db-product-variants [variantsForm]="variantsForm"
                         (apply)="applyVariations.emit()"
                         [attributes]="atts"
                         [activeAttributes]="activeAttributes">
    </db-product-variants>
  </div>
  <div class="product-variations-container" *ngIf="!!variantsDialogFormArray.controls?.length">
    <div class="title-container">
      <div class="variants-title">
        <div class="container-title">
          Product variations
        </div>
        <span class="ml5">
        <i class="db-icon db-icon-ds-info-bg"
           [dsTooltip]="'text_addProductAttributesDesc'|dbText"
           dsTooltipPosition="right"
           dsTooltipColor="black"
           dsTooltipAlign="top">
        </i>
      </span>
      </div>
      <div class="view-variants-link">
        <div class="container-action-link"
             (click)="openVariantsModal.emit(activeAttributes)">
          Edit all variations
        </div>
        <span class="count">{{ variantsDialogFormArray.controls?.length }}</span>
      </div>
    </div>
    <div class="variations-preview">
      <div class="variations-preview-header">
        <div class="variation">{{ 'text_variation' | dbText }}</div>
        <div class="price">{{ 'text_price' | dbText }}</div>
        <div class="available">{{ 'text_available' | dbText }}</div>
      </div>
      <div class="variations-preview-list">
        <ng-container *ngFor="let variant of variantsDialogFormArray.controls; let i = index;">
          <div class="variations-preview-list-item">
            <div class="variation-main-info">
              <div class="variation-number">#{{ i + 1 }}</div>
              <div class="separator"></div>
              <div class="variation-properties">
                <div class="variation-property"
                     *ngFor="let term of variant.get('options')?.value">
                  {{ term.name }}
                </div>
              </div>
            </div>
            <div class="variation-price">
              <div currencyMask [manualValue]="variant.get('price')?.value || 0.00" [symbol]="currency?.symbol">{{ variant.get('price')?.value || 0.00 }}</div>
            </div>
            <div class="variation-count">
              <div
                *ngIf="inventoryForm.get('track_quantity')?.value;else status">{{ variant.get('stock_quantity')?.value || 0 }}
              </div>
              <ng-template #status>
                <div>{{ statusOptions[variant.get('stock_status')?.value]}}</div>
              </ng-template>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</section>
